export enum CargoModalEntityType {
  CARGO = "CARGO",
  SCHEDULE_CARGO_TEMPLATE = "SCHEDULE_CARGO_TEMPLATE",
  CLIENT_CARGO_TEMPLATE = "CLIENT_CARGO_TEMPLATE",
}